import { makeStyles } from "@mui/styles";
import React from "react";
import { Route, Routes as Switch } from "react-router-dom";
import {
  ABOUT,
  BLOGS,
  CONTACT,
  DEBATES,
  HOME,
  NEWS,
  SOCIAL,
  VLOGS,
} from "../app/api/routes";
import { AppBarPublic } from "./common/appBar";
import Blog from "./Pages/Blog";
import Blogs from "./Pages/Blogs";
import Debates from "./Pages/Debates";
import HomePage from "./Pages/Home";
import News from "./Pages/News";
import SocialInitiatives from "./Pages/SocialInitiatives";
import Vlogs from "./Pages/Vlogs";

const useStyles = makeStyles((theme) => ({
  seperator: {
    [theme.breakpoints.down("md")]: {
      height: theme.APPBARHEIGHTMD,
    },
    [theme.breakpoints.down("sm")]: {
      height: theme.APPBARHEIGHTSM,
    },
    [theme.breakpoints.up("md")]: {
      height: theme.APPBARHEIGHTLG,
    },
  },
}));
const AppRoutes = (props) => {
  const classes = useStyles();
  return (
    <>
      <AppBarPublic />
      <div className={classes.seperator} />

      <Switch>
        <Route path={SOCIAL} element={<SocialInitiatives />} />

        <Route path={VLOGS} element={<Vlogs />} />
        <Route path={NEWS} element={<News />} />
        <Route path={DEBATES} element={<Debates />} />
        <Route path={`${BLOGS}/:id`} element={<Blog />} />

        <Route path={BLOGS} element={<Blogs />} />
        <Route path={CONTACT} element={<HomePage />} />
        <Route path={ABOUT} element={<HomePage />} />
        <Route path={HOME} element={<HomePage />} />
      </Switch>
    </>
  );
};

export default AppRoutes;
